/*
 * WSE Customizer — made-to-measure + interior customization (live preview).
 */
(function () {
  'use strict';

  function show(el, visible) {
    if (!el) return;
    if (visible) { el.removeAttribute('hidden'); el.style.display = ''; }
    else { el.style.display = 'none'; }
  }

  function luminance(hex) {
    var c = String(hex || '').replace('#', '');
    if (c.length === 3) c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2];
    if (c.length < 6) return 0.6;
    var r = parseInt(c.substr(0, 2), 16) / 255;
    var g = parseInt(c.substr(2, 2), 16) / 255;
    var b = parseInt(c.substr(4, 2), 16) / 255;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }
  function isDark(hex) { return luminance(hex) < 0.5; }

  function uuid() {
    return 'wse-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  var CM_PER_IN = 2.54;

  function roundMeasure(val, unit) {
    var n = parseFloat(val);
    if (isNaN(n)) return '';
    if (unit === 'in') return String(Math.round(n * 8) / 8);
    return String(Math.round(n * 2) / 2);
  }

  function valueToCm(val, unit) {
    var n = parseFloat(val);
    if (isNaN(n) || n <= 0) return null;
    if (unit === 'in') return Math.round(n * CM_PER_IN * 2) / 2;
    return Math.round(n * 2) / 2;
  }

  function cmToDisplay(cm, unit) {
    if (cm == null || isNaN(cm)) return '';
    if (unit === 'in') return roundMeasure(cm / CM_PER_IN, 'in');
    return roundMeasure(cm, 'cm');
  }

  function formatPrice(cents, currency) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  var WSE_PRODUCT_RANGES = [
    { prefix: 'fie-core', label: 'FIE Core' },
    { prefix: 'apex-pro', label: 'Apex Pro' },
    { prefix: 'academy', label: 'Academy' },
    { prefix: 'motion', label: 'Motion' },
    { prefix: 'coach', label: 'Coach' },
    { prefix: 'fie', label: 'FIE' },
    { prefix: 'apex', label: 'Apex' }
  ];

  function extractProductRange(product) {
    if (!product) return null;
    var handle = String(product.handle || '').replace(/^wse-/, '');
    var i;
    for (i = 0; i < WSE_PRODUCT_RANGES.length; i++) {
      if (handle.indexOf(WSE_PRODUCT_RANGES[i].prefix) === 0) return WSE_PRODUCT_RANGES[i].label;
    }
    var rest = String(product.title || '').replace(/^WSE\s+/i, '');
    for (i = 0; i < WSE_PRODUCT_RANGES.length; i++) {
      if (rest.indexOf(WSE_PRODUCT_RANGES[i].label) === 0) return WSE_PRODUCT_RANGES[i].label;
    }
    var match = rest.match(/^([A-Za-z]+(?:\s+[A-Za-z]+)?)/);
    return match ? match[1] : null;
  }

  function interpolate(template, vars) {
    var out = String(template || '');
    Object.keys(vars).forEach(function (key) {
      out = out.split('{{ ' + key + ' }}').join(vars[key]);
      out = out.split('{{' + key + '}}').join(vars[key]);
    });
    return out;
  }

  function initCustomizer(root) {
    var configEl = document.querySelector('script[data-cz-config]');
    var config = {};
    try { config = JSON.parse(configEl.textContent); } catch (e) { config = {}; }
    var cartAddUrl = (config.routes && config.routes.cartAdd) || '/cart/add.js';
    var checkoutUrl = (config.routes && config.routes.checkout) || '/checkout';
    var mode = root.getAttribute('data-mode') || config.mode || 'full';
    if (mode !== 'jacket_only' && mode !== 'pants_only') mode = 'full';

    var params = new URLSearchParams(window.location.search);
    var preselectHandle = params.get('product') || '';
    var loadSaveId = params.get('load') || '';

    var feeJacketCents = Number(config.customizationFeeJacketCents) || 5000;
    var feePantsCents = Number(config.customizationFeePantsCents) || 5000;

    var state = {
      mode: mode,
      wantJacket: mode !== 'pants_only',
      wantPants: mode !== 'jacket_only',
      view: 'ext-front',
      jacket: null, jacketVariant: '',
      pants: null, pantsVariant: '',
      jacketFit: 'Regular', pantsFit: 'Regular',
      jacketMeasures: {}, pantsMeasures: {},
      measureUnit: 'cm',
      notes: '',
      lining: { label: 'Royal Blue', color: '#1d4ed8', slug: 'bleu-roi', image: '' },
      collarText: '',
      backName: '',
      backCountry: ''
    };

    function storageKey() {
      return config.customerId ? ('wse-cz-saves-' + config.customerId) : 'wse-cz-saves-guest';
    }

    function eachCv(name, fn) {
      root.querySelectorAll('[data-cv="' + name + '"]').forEach(fn);
    }
    function setText(name, txt) { eachCv(name, function (el) { el.textContent = txt; }); }
    var openBaseImg = root.querySelector('[data-cz-open-base]');

    var VIEW_HINTS = {
      'ext-front': 'Jacket front — made to measure, no exterior marking.',
      'ext-back': 'Jacket back — optional name and country code on the upper back panel.',
      'open': 'Interior — lining, collar, and optional collar text.',
      'pants': 'Pants — front view.'
    };

    function updateViewHint() {
      var hintEl = root.querySelector('[data-cz-view-hint]');
      if (!hintEl) return;
      hintEl.textContent = VIEW_HINTS[state.view] || '';
    }

    function render() {
      root.querySelectorAll('[data-view]').forEach(function (v) {
        show(v, v.getAttribute('data-view') === state.view);
      });
      if (openBaseImg && state.lining.image) openBaseImg.setAttribute('src', state.lining.image);
      var collarTextColor = isDark(state.lining.color) ? '#ffffff' : '#0B132B';
      eachCv('collar-text', function (el) { el.style.color = collarTextColor; });
      setText('collar-text', state.collarText.toUpperCase());
      var backName = (state.backName || '').trim();
      var backCountry = (state.backCountry || '').trim();
      setText('back-name', backName.toUpperCase());
      setText('back-country', backCountry.toUpperCase());
      eachCv('back-name', function (el) { show(el, !!backName); });
      eachCv('back-country', function (el) { show(el, !!backCountry); });
      root.querySelectorAll('[data-cv-container="back-id"]').forEach(function (el) {
        show(el, !!(backName || backCountry));
      });
      updateViewHint();
      updatePrice();
    }

    function setView(view) {
      if (!view) return;
      state.view = view;
      root.querySelectorAll('[data-view-btn]').forEach(function (b) {
        var on = b.getAttribute('data-view-btn') === view;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      render();
    }

    function scrollToMeasureSection(kind) {
      var group = root.querySelector('[data-cz-group="' + kind + '-measures"]');
      var details = root.querySelector('[data-cz-inline-guide="' + kind + '"]');
      if (details) details.open = true;
      if (group) {
        group.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var firstEmpty = group.querySelector('[data-cz-measure="' + kind + '"]:invalid, [data-cz-measure="' + kind + '"][value=""]');
        if (!firstEmpty) {
          var inputs = group.querySelectorAll('[data-cz-measure="' + kind + '"]');
          for (var i = 0; i < inputs.length; i++) {
            if (!inputs[i].value.trim()) { firstEmpty = inputs[i]; break; }
          }
        }
        if (firstEmpty) setTimeout(function () { firstEmpty.focus(); }, 400);
      }
    }

    root.querySelectorAll('[data-view-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () { setView(btn.getAttribute('data-view-btn')); });
    });

    function includeJacket() {
      return state.mode !== 'pants_only' && state.wantJacket;
    }
    function includePants() {
      return state.mode !== 'jacket_only' && state.wantPants;
    }

    var jacketSel = root.querySelector('[data-cz-jacket-product]');
    var pantsSel = root.querySelector('[data-cz-pants-product]');

    function syncOrderRow(kind, active, hasProducts) {
      var row = root.querySelector('[data-cz-order-row="' + kind + '"]');
      if (!row) return;
      var cb = row.querySelector('[data-cz-want-' + kind + ']');
      var sel = row.querySelector('[data-cz-' + kind + '-product]');
      var showRow = kind === 'jacket'
        ? state.mode !== 'pants_only'
        : state.mode !== 'jacket_only';
      show(row, showRow);
      if (cb) {
        cb.disabled = state.mode !== 'full';
        show(cb.closest('.wse-cz__check--order'), state.mode === 'full');
      }
      row.classList.toggle('is-active', active);
      if (sel) sel.disabled = !active || !hasProducts;
    }

    function applyMode() {
      var showJacket = includeJacket();
      var showPants = includePants();
      var jacketHasProducts = jacketSel && jacketSel.options.length > 0;
      var pantsHasProducts = pantsSel && pantsSel.options.length > 0;
      syncOrderRow('jacket', showJacket, jacketHasProducts);
      syncOrderRow('pants', showPants, pantsHasProducts);
      root.querySelectorAll('[data-cz-view-kind]').forEach(function (btn) {
        var kind = btn.getAttribute('data-cz-view-kind');
        show(btn, (kind === 'jacket' && showJacket) || (kind === 'pants' && showPants));
      });
      ['jacket-measures', 'jacket-custom', 'pants-measures'].forEach(function (g) {
        var isJacket = g.indexOf('jacket') === 0;
        root.querySelectorAll('[data-cz-group="' + g + '"]').forEach(function (el) {
          show(el, isJacket ? showJacket : showPants);
        });
      });
      var personalizationStep = root.querySelector('[data-cz-step="personalization"]');
      if (personalizationStep) show(personalizationStep, showJacket);
      root.querySelectorAll('[data-cz-measure="jacket"]').forEach(function (input) {
        if (showJacket) input.setAttribute('required', '');
        else input.removeAttribute('required');
      });
      root.querySelectorAll('[data-cz-measure="pants"]').forEach(function (input) {
        if (showPants) input.setAttribute('required', '');
        else input.removeAttribute('required');
      });
      if (!showJacket && state.view !== 'pants' && showPants) setView('pants');
      if (!showPants && state.view === 'pants' && showJacket) setView('ext-front');
      updatePrice();
    }

    var wantJacketCb = root.querySelector('[data-cz-want-jacket]');
    var wantPantsCb = root.querySelector('[data-cz-want-pants]');
    function syncWantCheckboxes() {
      if (wantJacketCb) wantJacketCb.checked = state.wantJacket;
      if (wantPantsCb) wantPantsCb.checked = state.wantPants;
    }
    function onWantChange() {
      if (!wantJacketCb || !wantPantsCb) return;
      if (!wantJacketCb.checked && !wantPantsCb.checked) {
        if (this === wantJacketCb) wantJacketCb.checked = true;
        else wantPantsCb.checked = true;
        setStatus('Select at least a jacket or pants.', 'is-err');
        return;
      }
      state.wantJacket = wantJacketCb.checked;
      state.wantPants = wantPantsCb.checked;
      applyMode();
    }
    if (wantJacketCb) wantJacketCb.addEventListener('change', onWantChange);
    if (wantPantsCb) wantPantsCb.addEventListener('change', onWantChange);
    syncWantCheckboxes();

    function wireSwatches(selector, target, viewFor) {
      var group = root.querySelector(selector);
      if (!group) return;
      group.querySelectorAll('.wse-cz__swatch[data-value]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          group.querySelectorAll('.wse-cz__swatch').forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          state[target] = {
            label: sw.getAttribute('data-value'),
            color: sw.getAttribute('data-color'),
            slug: sw.getAttribute('data-slug') || '',
            image: sw.getAttribute('data-image') || ''
          };
          setView(viewFor);
        });
      });
      var active = group.querySelector('.wse-cz__swatch.is-active');
      if (active) {
        state[target].slug = active.getAttribute('data-slug') || state[target].slug;
        state[target].image = active.getAttribute('data-image') || state[target].image;
      }
    }
    wireSwatches('[data-cz-lining]', 'lining', 'open');

    var collarText = root.querySelector('[data-cz-collar-text]');
    if (collarText) collarText.addEventListener('input', function () { state.collarText = collarText.value; setView('open'); });
    var backNameEl = root.querySelector('[data-cz-back-name]');
    if (backNameEl) backNameEl.addEventListener('input', function () { state.backName = backNameEl.value; setView('ext-back'); });
    var backCountryEl = root.querySelector('[data-cz-back-country]');
    if (backCountryEl) backCountryEl.addEventListener('input', function () { state.backCountry = backCountryEl.value; setView('ext-back'); });

    function applyMeasureBounds(input, unit) {
      var minCm = parseFloat(input.getAttribute('data-cz-min-cm'));
      var maxCm = parseFloat(input.getAttribute('data-cz-max-cm'));
      if (isNaN(minCm) || isNaN(maxCm)) return;
      if (unit === 'in') {
        input.min = roundMeasure(minCm / CM_PER_IN, 'in');
        input.max = roundMeasure(maxCm / CM_PER_IN, 'in');
        input.step = '0.125';
        input.placeholder = 'in';
      } else {
        input.min = String(minCm);
        input.max = String(maxCm);
        input.step = '0.5';
        input.placeholder = 'cm';
      }
    }

    function updateMeasureUnitUI() {
      var unit = state.measureUnit;
      var suffix = unit === 'in' ? '(in)' : '(cm)';
      root.querySelectorAll('[data-cz-unit-suffix]').forEach(function (el) { el.textContent = suffix; });
      root.querySelectorAll('[data-unit-btn]').forEach(function (btn) {
        var on = btn.getAttribute('data-unit-btn') === unit;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function setMeasureUnit(unit) {
      if (unit !== 'cm' && unit !== 'in') return;
      if (unit === state.measureUnit) return;
      var prev = state.measureUnit;
      state.measureUnit = unit;
      root.querySelectorAll('[data-cz-measure]').forEach(function (input) {
        var raw = input.value.trim();
        if (raw) {
          var cm = valueToCm(raw, prev);
          input.value = cmToDisplay(cm, unit);
        }
        applyMeasureBounds(input, unit);
      });
      updateMeasureUnitUI();
      collectMeasures('jacket');
      collectMeasures('pants');
    }

    root.querySelectorAll('[data-unit-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () { setMeasureUnit(btn.getAttribute('data-unit-btn')); });
    });
    root.querySelectorAll('[data-cz-measure]').forEach(function (input) {
      applyMeasureBounds(input, state.measureUnit);
      input.addEventListener('input', function () {
        collectMeasures(input.getAttribute('data-cz-measure'));
      });
    });
    updateMeasureUnitUI();
    var jacketFit = root.querySelector('[data-cz-jacket-fit]');
    if (jacketFit) jacketFit.addEventListener('change', function () { state.jacketFit = jacketFit.value; });
    var pantsFit = root.querySelector('[data-cz-pants-fit]');
    if (pantsFit) pantsFit.addEventListener('change', function () { state.pantsFit = pantsFit.value; });
    var notesEl = root.querySelector('[data-cz-notes]');
    if (notesEl) notesEl.addEventListener('input', function () { state.notes = notesEl.value; });

    function collectMeasures(kind) {
      var out = {};
      root.querySelectorAll('[data-cz-measure="' + kind + '"]').forEach(function (input) {
        var key = input.getAttribute('data-cz-key');
        out[key] = { label: input.getAttribute('data-cz-label') || key, value: input.value.trim() };
      });
      state[kind === 'jacket' ? 'jacketMeasures' : 'pantsMeasures'] = out;
      return out;
    }

    function measuresComplete(kind) {
      var measures = collectMeasures(kind);
      var keys = Object.keys(measures);
      return keys.length && keys.every(function (k) {
        var v = parseFloat(measures[k].value);
        return measures[k].value !== '' && !isNaN(v) && v > 0;
      });
    }

    function formatMeasures(measures, unit) {
      var u = unit || state.measureUnit;
      var suffix = u === 'in' ? ' in' : ' cm';
      return Object.keys(measures).sort().map(function (k) {
        return k + ' ' + measures[k].label + ': ' + measures[k].value + suffix;
      }).join(' | ');
    }

    function measuresToCm(measures, fromUnit) {
      var out = {};
      Object.keys(measures).forEach(function (k) {
        var cm = valueToCm(measures[k].value, fromUnit);
        out[k] = {
          label: measures[k].label,
          value: cm != null ? String(cm) : ''
        };
      });
      return out;
    }

    function jacketProperties() {
      var unitLabel = state.measureUnit === 'in' ? 'Inches (in)' : 'Centimeters (cm)';
      var backName = (state.backName || '').trim();
      var backCountry = (state.backCountry || '').trim();
      return {
        '_wse_customization': 'true',
        '_wse_made_to_measure': 'true',
        'Type': 'Custom jacket',
        'Customization fee': formatPrice(feeJacketCents, config.currency),
        'Fit': state.jacketFit,
        'Input unit': unitLabel,
        'Jacket measurements': formatMeasures(state.jacketMeasures, state.measureUnit),
        'Jacket measurements (cm workshop)': formatMeasures(measuresToCm(state.jacketMeasures, state.measureUnit), 'cm'),
        'Lining & collar': state.lining.label + ' (' + state.lining.color + ')' + (state.collarText ? ' — collar: « ' + state.collarText + ' »' : ''),
        'Back name': backName || '—',
        'Country code': backCountry ? backCountry.toUpperCase() : '—',
        'No returns': 'Confirmed by customer',
        'Notes': state.notes || '—'
      };
    }

    function pantsProperties() {
      var unitLabel = state.measureUnit === 'in' ? 'Inches (in)' : 'Centimeters (cm)';
      return {
        '_wse_customization': 'true',
        '_wse_made_to_measure': 'true',
        'Type': 'Custom pants',
        'Customization fee': formatPrice(feePantsCents, config.currency),
        'Fit': state.pantsFit,
        'Input unit': unitLabel,
        'Pants measurements': formatMeasures(state.pantsMeasures, state.measureUnit),
        'Pants measurements (cm workshop)': formatMeasures(measuresToCm(state.pantsMeasures, state.measureUnit), 'cm'),
        'No returns': 'Confirmed by customer',
        'Notes': state.notes || '—'
      };
    }

    var statusEl = root.querySelector('[data-cz-products-status]');
    var priceEl = root.querySelector('[data-cz-price-value]');
    var priceJacketBaseEl = root.querySelector('[data-cz-price-jacket-base]');
    var priceJacketCustomEl = root.querySelector('[data-cz-price-jacket-custom]');
    var pricePantsBaseEl = root.querySelector('[data-cz-price-pants-base]');
    var pricePantsCustomEl = root.querySelector('[data-cz-price-pants-custom]');
    var priceJacketBaseRow = root.querySelector('[data-cz-price-jacket-base-row]');
    var priceJacketCustomRow = root.querySelector('[data-cz-price-jacket-custom-row]');
    var pricePantsBaseRow = root.querySelector('[data-cz-price-pants-base-row]');
    var pricePantsCustomRow = root.querySelector('[data-cz-price-pants-custom-row]');
    var priceJacketBaseLabelEl = root.querySelector('[data-cz-price-jacket-base-label]');
    var pricePantsBaseLabelEl = root.querySelector('[data-cz-price-pants-base-label]');
    var rangeTipEl = root.querySelector('[data-cz-range-tip]');
    var rangeWarnEl = root.querySelector('[data-cz-range-warn]');
    var rangeWarnMsgEl = root.querySelector('[data-cz-range-warn-msg]');
    var rangeConfirmWrapEl = root.querySelector('[data-cz-range-confirm-wrap]');
    var rangeConfirmEl = root.querySelector('[data-cz-range-confirm]');
    var i18n = config.i18n || {};

    function isJacket(p) { var t = p.title.toLowerCase(); return t.indexOf('jacket') !== -1 && t.indexOf('lame') === -1; }
    function isPants(p) { var t = p.title.toLowerCase(); return t.indexOf('pant') !== -1 || t.indexOf('breech') !== -1; }

    function firstVariant(product) {
      return product && product.variants && product.variants.length ? product.variants[0] : null;
    }

    function variantPriceCents(v) {
      if (!v || v.price == null) return 0;
      var raw = String(v.price).replace(',', '.');
      var p = parseFloat(raw);
      if (isNaN(p)) return 0;
      if (raw.indexOf('.') !== -1 || p < 1000) return Math.round(p * 100);
      return Math.round(p);
    }

    function getRangeMismatch() {
      if (!includeJacket() || !includePants() || !state.jacket || !state.pants) return null;
      var jacketRange = extractProductRange(state.jacket);
      var pantsRange = extractProductRange(state.pants);
      if (!jacketRange || !pantsRange || jacketRange === pantsRange) return null;
      return { jacket: jacketRange, pants: pantsRange };
    }

    function updateRangeUI() {
      var bothSelected = includeJacket() && includePants() && state.jacket && state.pants;
      var mismatch = getRangeMismatch();
      if (rangeTipEl) show(rangeTipEl, !!bothSelected && !mismatch);
      if (rangeWarnEl) {
        show(rangeWarnEl, !!mismatch);
        if (mismatch && rangeWarnMsgEl) {
          rangeWarnMsgEl.textContent = interpolate(
            i18n.rangeMismatchWarning || 'Your jacket ({{ jacket_range }}) and pants ({{ pants_range }}) are from different ranges. Matching ranges is strongly recommended.',
            { jacket_range: mismatch.jacket, pants_range: mismatch.pants }
          );
        }
      }
      if (rangeConfirmWrapEl) show(rangeConfirmWrapEl, !!mismatch);
      if (!mismatch && rangeConfirmEl) rangeConfirmEl.checked = false;
    }

    function updatePrice() {
      var jBase = 0;
      var pBase = 0;
      var jCustom = 0;
      var pCustom = 0;
      if (includeJacket()) {
        jCustom = feeJacketCents;
        if (state.jacket) jBase = variantPriceCents(firstVariant(state.jacket));
      }
      if (includePants()) {
        pCustom = feePantsCents;
        if (state.pants) pBase = variantPriceCents(firstVariant(state.pants));
      }
      var total = jBase + pBase + jCustom + pCustom;
      if (priceJacketBaseRow) show(priceJacketBaseRow, includeJacket() && jBase > 0);
      if (priceJacketCustomRow) show(priceJacketCustomRow, includeJacket());
      if (pricePantsBaseRow) show(pricePantsBaseRow, includePants() && pBase > 0);
      if (pricePantsCustomRow) show(pricePantsCustomRow, includePants());
      if (priceJacketBaseLabelEl) {
        priceJacketBaseLabelEl.textContent = state.jacket && state.jacket.title
          ? state.jacket.title
          : (i18n.summaryJacketFallback || 'Jacket');
      }
      if (pricePantsBaseLabelEl) {
        pricePantsBaseLabelEl.textContent = state.pants && state.pants.title
          ? state.pants.title
          : (i18n.summaryPantsFallback || 'Pants');
      }
      if (priceJacketBaseEl) priceJacketBaseEl.textContent = jBase ? formatPrice(jBase, config.currency) : '—';
      if (priceJacketCustomEl) priceJacketCustomEl.textContent = formatPrice(jCustom, config.currency);
      if (pricePantsBaseEl) pricePantsBaseEl.textContent = pBase ? formatPrice(pBase, config.currency) : '—';
      if (pricePantsCustomEl) pricePantsCustomEl.textContent = formatPrice(pCustom, config.currency);
      if (priceEl) priceEl.textContent = total ? formatPrice(total, config.currency) : '—';
      updateRangeUI();
    }

    function fetchCollection(handle) {
      return fetch('/collections/' + handle + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }

    function loadProducts() {
      var jh = root.getAttribute('data-jacket-collection') || config.jacketCollection || 'uniforms';
      var ph = root.getAttribute('data-pants-collection') || config.pantsCollection || 'uniforms';
      var handles = jh === ph ? [jh] : [jh, ph];
      Promise.all(handles.map(fetchCollection)).then(function (lists) {
        var all = [];
        lists.forEach(function (l) { all = all.concat(l); });
        var jackets = all.filter(isJacket);
        var pants = all.filter(isPants);
        if (!jackets.length && !pants.length) {
          if (statusEl) statusEl.textContent = 'Products unavailable — please try again later.';
          return;
        }
        if (statusEl) statusEl.style.display = 'none';

        function populate(sel, items, stateKey, varKey, handleToSelect) {
          if (!sel) return;
          sel.innerHTML = '';
          var selectedIndex = 0;
          items.forEach(function (p, i) {
            var opt = document.createElement('option');
            opt.value = i;
            opt.textContent = p.title;
            sel.appendChild(opt);
            if (handleToSelect && p.handle === handleToSelect) selectedIndex = i;
          });
          sel.disabled = !items.length;
          function sync() {
            var p = items[sel.value];
            state[stateKey] = p || null;
            var v = firstVariant(p);
            state[varKey] = v ? String(v.id) : '';
            updatePrice();
          }
          sel.addEventListener('change', sync);
          if (items.length) { sel.value = String(selectedIndex); sync(); }
        }

        var jacketHandle = (state.mode === 'jacket_only' || state.mode === 'full') ? preselectHandle : '';
        var pantsHandle = (state.mode === 'pants_only' || state.mode === 'full') ? preselectHandle : '';
        populate(jacketSel, jackets, 'jacket', 'jacketVariant', jacketHandle);
        populate(pantsSel, pants, 'pants', 'pantsVariant', pantsHandle);
        applyMode();
        if (loadSaveId) loadSave(loadSaveId);
      });
    }
    loadProducts();

    var statusMsg = root.querySelector('[data-cz-status]');
    var noReturn = root.querySelector('[data-cz-noreturn]');

    function setStatus(msg, kind) {
      if (!statusMsg) return;
      statusMsg.textContent = msg;
      statusMsg.classList.remove('is-ok', 'is-err');
      if (kind) statusMsg.classList.add(kind);
    }

    function validateBeforeCart() {
      if (noReturn && !noReturn.checked) {
        setStatus('Please confirm the no-return policy for made-to-measure items.', 'is-err');
        noReturn.focus();
        return false;
      }
      collectMeasures('jacket');
      collectMeasures('pants');
      if (notesEl) state.notes = notesEl.value;
      if (!includeJacket() && !includePants()) {
        setStatus('Select at least a jacket or pants.', 'is-err');
        return false;
      }
      if (includeJacket()) {
        if (!state.jacket || !state.jacketVariant) { setStatus('Select a jacket range.', 'is-err'); return false; }
        if (!measuresComplete('jacket')) { setStatus('Enter all jacket measurements (A–I).', 'is-err'); scrollToMeasureSection('jacket'); return false; }
      }
      if (includePants()) {
        if (!state.pants || !state.pantsVariant) { setStatus('Select a pants range.', 'is-err'); return false; }
        if (!measuresComplete('pants')) { setStatus('Enter all pants measurements (A–H).', 'is-err'); scrollToMeasureSection('pants'); return false; }
      }
      var mismatch = getRangeMismatch();
      if (mismatch && (!rangeConfirmEl || !rangeConfirmEl.checked)) {
        setStatus(i18n.rangeMismatchConfirmRequired || 'Please confirm that you understand the jacket and pants are from different ranges.', 'is-err');
        if (rangeConfirmEl) {
          rangeConfirmEl.focus();
          if (rangeConfirmWrapEl) rangeConfirmWrapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      }
      return true;
    }

    function buildCartItems() {
      var items = [];
      if (includeJacket() && state.jacket && state.jacketVariant) {
        items.push({ id: Number(state.jacketVariant), quantity: 1, properties: jacketProperties() });
      }
      if (includePants() && state.pants && state.pantsVariant) {
        items.push({ id: Number(state.pantsVariant), quantity: 1, properties: pantsProperties() });
      }
      return items;
    }

    function addToCart(goCheckout) {
      if (!validateBeforeCart()) return;
      var items = buildCartItems();
      if (!items.length) { setStatus('No items to add.', 'is-err'); return; }
      var addBtn = root.querySelector('[data-cz-add]');
      var checkoutBtn = root.querySelector('[data-cz-checkout]');
      if (addBtn) addBtn.disabled = true;
      if (checkoutBtn) checkoutBtn.disabled = true;
      setStatus('Adding to cart…', null);
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (addBtn) addBtn.disabled = false;
          if (checkoutBtn) checkoutBtn.disabled = false;
          if (res.ok) {
            setStatus(goCheckout ? 'Redirecting to checkout…' : 'Added to cart.', 'is-ok');
            document.dispatchEvent(new CustomEvent('wse:cart:updated'));
            if (goCheckout) window.location.href = checkoutUrl;
          } else {
            setStatus('Error: ' + (res.data && res.data.description ? res.data.description : 'variant unavailable'), 'is-err');
          }
        })
        .catch(function () {
          if (addBtn) addBtn.disabled = false;
          if (checkoutBtn) checkoutBtn.disabled = false;
          setStatus('Network error.', 'is-err');
        });
    }

    var form = root.querySelector('[data-cz-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });
    var addBtn = root.querySelector('[data-cz-add]');
    if (addBtn) addBtn.addEventListener('click', function () { addToCart(false); });
    var checkoutBtn = root.querySelector('[data-cz-checkout]');
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () { addToCart(true); });

    function serializeState() {
      return {
        mode: state.mode,
        wantJacket: state.wantJacket,
        wantPants: state.wantPants,
        jacketHandle: state.jacket ? state.jacket.handle : '',
        pantsHandle: state.pants ? state.pants.handle : '',
        jacketFit: state.jacketFit,
        pantsFit: state.pantsFit,
        jacketMeasures: state.jacketMeasures,
        pantsMeasures: state.pantsMeasures,
        measureUnit: state.measureUnit,
        notes: state.notes,
        lining: state.lining,
        collarText: state.collarText,
        backName: state.backName,
        backCountry: state.backCountry
      };
    }

    function applySerialized(data) {
      if (!data) return;
      if (data.jacketFit && jacketFit) { jacketFit.value = data.jacketFit; state.jacketFit = data.jacketFit; }
      if (data.pantsFit && pantsFit) { pantsFit.value = data.pantsFit; state.pantsFit = data.pantsFit; }
      if (data.notes && notesEl) { notesEl.value = data.notes; state.notes = data.notes; }
      if (data.collarText && collarText) { collarText.value = data.collarText; state.collarText = data.collarText; }
      if (data.backName != null && backNameEl) { backNameEl.value = data.backName; state.backName = data.backName; }
      else if (data.exteriorName != null && backNameEl) { backNameEl.value = data.exteriorName; state.backName = data.exteriorName; }
      if (data.backCountry != null && backCountryEl) { backCountryEl.value = data.backCountry; state.backCountry = data.backCountry; }
      else if (data.exteriorCountry != null && backCountryEl) { backCountryEl.value = data.exteriorCountry; state.backCountry = data.exteriorCountry; }
      if (typeof data.wantJacket === 'boolean') {
        state.wantJacket = data.wantJacket;
        if (state.mode === 'pants_only') state.wantJacket = false;
        if (state.mode === 'jacket_only') state.wantJacket = true;
      }
      if (typeof data.wantPants === 'boolean') {
        state.wantPants = data.wantPants;
        if (state.mode === 'jacket_only') state.wantPants = false;
        if (state.mode === 'pants_only') state.wantPants = true;
      }
      syncWantCheckboxes();
      if (data.measureUnit === 'cm' || data.measureUnit === 'in') {
        state.measureUnit = data.measureUnit;
        root.querySelectorAll('[data-cz-measure]').forEach(function (input) {
          applyMeasureBounds(input, state.measureUnit);
        });
        updateMeasureUnitUI();
      }
      ['jacket', 'pants'].forEach(function (kind) {
        var m = data[kind + 'Measures'];
        if (!m) return;
        Object.keys(m).forEach(function (k) {
          var input = root.querySelector('[data-cz-measure="' + kind + '"][data-cz-key="' + k + '"]');
          if (input) input.value = m[k].value || '';
        });
        collectMeasures(kind);
      });
      if (data.lining) {
        state.lining = data.lining;
        var liningGroup = root.querySelector('[data-cz-lining]');
        if (liningGroup) liningGroup.querySelectorAll('.wse-cz__swatch').forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-value') === data.lining.label);
        });
      }
      applyMode();
      render();
    }

    function readSaves() {
      try { return JSON.parse(localStorage.getItem(storageKey()) || '[]'); } catch (e) { return []; }
    }
    function writeSaves(items) { localStorage.setItem(storageKey(), JSON.stringify(items)); }

    function loadSave(id) {
      var item = readSaves().filter(function (s) { return s.id === id; })[0];
      if (item) applySerialized(item.data);
    }

    var saveBtn = root.querySelector('[data-cz-save]');
    var saveLabel = root.querySelector('[data-cz-save-label]');
    if (saveBtn) saveBtn.addEventListener('click', function () {
      if (!config.customerId) {
        setStatus('Sign in to save to your profile.', 'is-err');
        return;
      }
      collectMeasures('jacket');
      collectMeasures('pants');
      var label = (saveLabel && saveLabel.value.trim()) || 'Configuration ' + new Date().toLocaleDateString('en-US');
      var loadUrl = (config.loadUrls && config.loadUrls[state.mode]) || '/pages/custom';
      var entry = {
        id: uuid(),
        label: label,
        updatedAt: new Date().toISOString(),
        loadUrl: loadUrl,
        data: serializeState()
      };
      var saves = readSaves();
      saves.unshift(entry);
      if (saves.length > 12) saves = saves.slice(0, 12);
      writeSaves(saves);
      setStatus('Saved to your profile (« ' + label + ' »).', 'is-ok');
    });

    var downloadBtn = root.querySelector('[data-cz-download]');
    if (downloadBtn) downloadBtn.addEventListener('click', function () {
      collectMeasures('jacket');
      collectMeasures('pants');
      var summary = {
        type: 'WSE Made-to-Measure Summary',
        generatedAt: new Date().toISOString(),
        products: {
          jacket: state.jacket ? state.jacket.title : null,
          pants: state.pants ? state.pants.title : null
        },
        jacket: jacketProperties(),
        pants: state.pants ? pantsProperties() : null,
        estimatedPrice: priceEl ? priceEl.textContent : null
      };
      var blob = new Blob([JSON.stringify(summary, null, 2)], { type: 'application/json' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'wse-made-to-measure-' + Date.now() + '.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
      setStatus('Summary downloaded.', 'is-ok');
    });

    applyMode();
    render();
    root._wseCustomizer = { state: state, serializeState: serializeState, applySerialized: applySerialized };
  }

  function boot() {
    document.querySelectorAll('[data-wse-customizer]').forEach(initCustomizer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
